// extracted by mini-css-extract-plugin
export default {"modal":"OrganizationOnboardingModal-module__modal--879DD","animatedBackground":"OrganizationOnboardingModal-module__animatedBackground--uHoG5"};